import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import { PermissionType } from 'src/types/permission';

export interface TopBlockPropsType {
    data: PermissionType | null;
    idPermission: string | undefined;
    newPermission: boolean;
    disableEdit: boolean;
    disableDelete: boolean;
    handleSave: () => void;
    handleDeletePermission: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        icon: <DeleteIcon />,
                        onClick: () => {
                            props.handleDeletePermission();
                        },
                        tooltip: translate('permissionDetail.deletePermission'),
                        hidden: props.disableDelete,
                        variant: 'outlined',
                    },
                    {
                        label: translate(props.newPermission ? 'permissionDetail.create' : 'permissionDetail.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
